import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useContext } from 'react';
import { PromptPortal } from '../PromptPortal';
import { usePromptController, PromptControllerProvider } from './PromptController';
import { ConfirmationModalFactory } from './Prompts/ConfirmationModalFactory';
var PromptContext = /*#__PURE__*/React.createContext(null);

var PromptProvider = function PromptProvider(_ref) {
  var children = _ref.children;

  var _usePromptController = usePromptController(),
      setModalController = _usePromptController.setModalController;

  var ConfirmationModalPrompt = function ConfirmationModalPrompt(config) {
    return setModalController( /*#__PURE__*/React.createElement(GenericModalController, {
      modalFactory: ConfirmationModalFactory,
      config: config
    }));
  };

  return /*#__PURE__*/React.createElement(PromptContext.Provider, {
    value: {
      openPrompt: {
        ConfirmationModal: ConfirmationModalPrompt
      }
    }
  }, children);
};

var PromptProviderV3 = function PromptProviderV3(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(PromptControllerProvider, null, /*#__PURE__*/React.createElement(PromptProvider, null, children));
};

var usePrompt = function usePrompt() {
  return useContext(PromptContext);
};

var GenericModalController = function GenericModalController(_ref3) {
  var modalFactory = _ref3.modalFactory,
      config = _ref3.config;

  var _usePromptController2 = usePromptController(),
      setModalController = _usePromptController2.setModalController;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isQueued = _useState4[0],
      setIsQueued = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var closeModal = function closeModal() {
    setIsOpen(false);
  };

  var handleCloseComplete = function handleCloseComplete() {
    setModalController(null);
    setIsQueued(false);
  };

  var Modal = modalFactory(config, {
    closeModal: closeModal,
    handleCloseComplete: handleCloseComplete,
    setIsLoading: setIsLoading
  });
  return /*#__PURE__*/React.createElement(PromptPortal, {
    shouldShow: isQueued
  }, Modal({
    isOpen: isOpen,
    isLoading: isLoading
  }));
};

export { PromptProviderV3, usePrompt };